import axios from 'axios'

export const api = axios.create({
    timeout: 15000,
    withCredentials: true
});

const handleResponse = (res, resolve, reject) => {
    (res.status == 200) ? resolve(res.data) : reject(res.statusText);
}

export function apiGet(endPoint, config) {
    return new Promise((resolve, reject) => {
        api.get(endPoint, config)
            .then(res => handleResponse(res, resolve, reject))
            .catch(reason => reject(reason));
    });
}

